import { createEndpoints } from '../../_helpers/utile/endpoint.helper';

export const AUTH_ENDPOINTS = {
  V1: createEndpoints('v1', {
    LOGIN: '/auth/login/',
    REFRESH: '/auth/refresh/',
    RECOVER_PASSWORD: '/user/send_verification_code/',
    RESET_PASSWORD: '/user/reset_password/',
    UPDATE_USER_DATA: (id: number) => `/user/${id}/`,
  }),
} as const;
